// extracted by mini-css-extract-plugin
export var carrierTab = "_4f-0";
export var carrierTabActive = "_4f-1 _4f-0";
export var carrierTabInactive = "_4f-2 _4f-0";
export var carrierTabLabel = "_4f-3";
export var carrierTabLabelActive = "_4f-4 _4f-3";
export var carrierTabLabelInactive = "_4f-5 _4f-3";
export var carrierTabPercentage = "_4f-6";
export var carrierTabPercentageActive = "_4f-7 _4f-6";
export var carrierTabPercentageInactive = "_4f-8 _4f-6";
export var carrierTabWinnable = "_4f-9";
export var carrierTabWinnableActive = "_4f-a _4f-9";
export var carrierTabWinnableInactive = "_4f-b _4f-9";
export var comparisonContainer = "_4f-d";
export var missingRateButton = "_4f-n";
export var missingRateButtonActive = "_4f-o _4f-n";
export var missingRateButtonInactive = "_4f-p _4f-n";
export var missingRateButtonLabel = "_4f-q";
export var missingRateButtonLabelActive = "_4f-r _4f-q";
export var missingRateButtonLabelInactive = "_4f-s _4f-q";
export var sidebar = "_4f-c";
export var strategyButton = "_4f-e";
export var strategyButtonActive = "_4f-f _4f-e";
export var strategyButtonDescription = "_4f-k";
export var strategyButtonDescriptionActive = "_4f-l _4f-k";
export var strategyButtonDescriptionInactive = "_4f-m _4f-k";
export var strategyButtonInactive = "_4f-g _4f-e";
export var strategyButtonLabel = "_4f-h";
export var strategyButtonLabelActive = "_4f-i _4f-h";
export var strategyButtonLabelInactive = "_4f-j _4f-h";
export var unitToggleButton = "_4f-t";
export var unitToggleButtonActive = "_4f-u _4f-t";
export var unitToggleButtonInactive = "_4f-v _4f-t";
export var unitToggleButtonLabel = "_4f-w";
export var unitToggleButtonLabelActive = "_4f-x _4f-w";
export var unitToggleButtonLabelInactive = "_4f-y _4f-w";